<template>
  <div
    :class="[
      'hab-flex',
      {
        [`${className}`]: className,
        [`align-${align}`]: align,
        [`wrap-${wrap}`]: wrap,
        [`direction-${direction}`]: direction,
        [`justify-${justify}`]: justify,
        [`gap-${gap}`]: gap,
      },
    ]"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    className: {
      type: String,
      default: "",
    },
    align: {
      type: String,
      default: "",
    },
    wrap: {
      type: String,
      default: "",
    },
    direction: {
      type: String,
      default: "",
    },
    justify: {
      type: String,
      default: "",
    },
    gap: {
      type: String,
      default: "",
    },
  },
};
</script>

<style lang="scss" scoped>
.hab-flex {
  display: flex;
  > div {
    min-width: 0;
  }
  &.wrap {
    &-wrap {
      flex-wrap: wrap;
    }
    &-nowrap {
      flex-wrap: nowrap;
    }
  }
  &.direction {
    &-column {
      flex-direction: column;
    }
    &-row {
      flex-direction: row;
    }
  }
  &.align {
    &-center {
      align-items: center;
    }
    &-flex-start {
      align-items: flex-start;
    }
    &-flex-start {
      align-items: flex-end;
    }
  }
  &.justify {
    &-center {
      justify-content: center;
    }
    &-space-between {
      justify-content: space-between;
    }
    &-space-around {
      justify-content: space-around;
    }
    &-flex-end {
      justify-content: flex-end;
    }
  }
  &.gap {
    &-5 {
      gap: 5px;
    }
    &-10 {
      gap: 10px;
    }
    &-15 {
      gap: 15px;
    }
    &-14 {
      gap: 14px;
    }
    &-20 {
      gap: 20px;
    }
    &-30 {
      gap: 30px;
    }
  }
}
</style>
